import template from './cbax-instock-amazon-config.html.twig';

const { Component, Mixin } = Shopware;

Component.register('cbax-instock-amazon-config', {
    template,

	inject: [
        'repositoryFactory'
    ],

    mixins: [
        Mixin.getByName('placeholder'),
        Mixin.getByName('notification')
    ],

    shortcuts: {
        'SYSTEMKEY+S': 'onSave'
    },

    metaInfo() {
        return {
            title: this.$createTitle(),
        };
    },

    data() {
        // für die SW6 Single-Select-Entity Felder wird ein festes Feld benötigt
        let config = {
            merchantId: '',
            marketplace: null,
            productStreamId: '',
            instockSettings: '',
            deliveryTime: '',
            restockTime: '',
            priceRuleId: '',
            maxStock: null,
            reservedStock: 0,
            fixedStock: null
        };
        let errors = {
            merchantId: null,
            marketplace: null,
            productStreamId: null,
            instockSettings: null,
            deliveryTime: null,
            restockTime: null,
            priceRuleId: null,
            maxStock: null,
            reservedStock: null,
            fixedStock: null
        };
        return {
            marketplaceName: 'amazon',
            configs: config,
            isSaveSuccessful: false,
            isLoading: false,
            errors: errors
        };
    },

	computed: {
		configRepository() {
            return this.repositoryFactory.create('system_config');
        },

        tooltipSave() {
            const systemKey = this.$device.getSystemKey();

            return {
                message: `${systemKey} + S`,
                appearance: 'light'
            };
        },

        tooltipCancel() {
            return {
                message: 'ESC',
                appearance: 'light'
            };
        },

        stockFieldsDisabled() {
		    return this.configs.instockSettings === 'price' || this.configs.fixedStock != null;
        },

        fixedStockFieldDisabled() {
            return this.configs.instockSettings === 'price';
        }
    },

	created() {
        this.isLoading = true;

		const configCriteria = new Shopware.Data.Criteria(1, 100);
        configCriteria.addFilter(Shopware.Data.Criteria.contains('configurationKey', 'CbaxModulInstockExportAmazon'));

		this.configRepository.search(configCriteria, Shopware.Context.api).then((searchResult) => {
			searchResult.forEach((item) => {
                const keyArray = item.configurationKey.split('.');
                let key;
                if (keyArray.length === 3) {
                    key = keyArray[2];
                    this.configs[key] = this.renderSpezialFields(key, item.configurationValue);
                }
			});
        }).then(() => {
            this.isLoading = false;
        });
    },

    methods: {
        onSave() {
            this.isLoading = true;

            // httpClient holen
            const initContainer = Shopware.Application.getContainer('init');
            const httpClient = initContainer.httpClient;
            const loginService = Shopware.Service('loginService');

            if (typeof this.configs.deliveryTime == 'number') {
                this.configs.deliveryTime = this.configs.deliveryTime.toString();
            }

            if (typeof this.configs.restockTime == 'number') {
                this.configs.restockTime = this.configs.restockTime.toString();
            }

            // Konfig speichern
            // Ajax-Request an den Controller schicken
            httpClient.post('/cbax/instockamazon/savePluginConfig', {configs: this.configs}, {
                headers: {
                    Authorization: `Bearer ${loginService.getToken()}`,
                }
            }).then((responseSave) => {
                this.isLoading = false;
                if (responseSave.data && responseSave.data.success && responseSave.data.success == true) {
                    this.isSaveSuccessful = true;
                } else {
                    let message = this.$tc('cbax-instock-amazon-config.notifications.failure.save');
                    if (responseSave.data && responseSave.data.message && responseSave.data.message !== '') {
                        message = responseSave.data.message;
                    }
                    this.createNotificationError({
                        title: this.$tc('cbax-instock-amazon-config.notifications.failure.title'),
                        message: message,
                    });
                }
            }).catch((err) => {
                this.isLoading = false;

                if (err.response.data && err.response.data.errors) {
                    err.response.data.errors.forEach((error) => {
                        if (error.code === 'VIOLATION::IS_BLANK_ERROR') {
                            const errorRow = error.source.pointer.replace('/', '');
                            error.code = 'c1051bb4-d103-4f74-8988-acbcafc7fdc3';
                            this.errors[errorRow] = error;
                        }
                    });
                }

                this.createNotificationError({
                    title: this.$tc('cbax-instock-amazon-config.notifications.failure.title'),
                    message: this.$tc('cbax-instock-amazon-config.notifications.failure.save'),
                });
            });
        },

        saveFinish() {
            this.isSaveSuccessful = false;
        },

        onChangeField($event, field) {
            if (this.configs[field] === undefined) {
                this.configs[field] = '';
            }
            this.configs[field] = $event;
            if (this.errors[field] !== undefined) {
                this.errors[field] = null;
            }
        },

        renderSpezialFields(key, value) {
            switch (key) {
                //case 'marketplace':
                    //return value.split(', ');
                case 'marketplace':
                    if (value.includes('A1PA6795UKMFR9')) {
                        return 'A1PA6795UKMFR9';
                    } else {
                        let marketplacesArray = value.split(', ');
                        return marketplacesArray[0];
                    }
                case 'deliveryTime':
                    return parseInt(value, 10);
                case 'restockTime':
                    return parseInt(value, 10);
                default:
                    return value;
            }
        },

        onExportInstock() {
            this.isLoading = true;

            // httpClient holen
            const initContainer = Shopware.Application.getContainer('init');
            const httpClient = initContainer.httpClient;
            const loginService = Shopware.Service('loginService');

            // Lagerbestand exportieren
            // Ajax-Request an den Controller schicken
            httpClient.post('/cbax/instockamazon/exportInstock', {configs: this.configs}, {
                headers: {
                    Authorization: `Bearer ${loginService.getToken()}`,
                }
            }).then((responseExport) => {
                this.isLoading = false;
                if (responseExport.data !== undefined && responseExport.data.success !== undefined && responseExport.data.success == true) {
                    this.isSaveSuccessful = true;
                    let message = this.$t('cbax-instock-amazon-config.notifications.success.export');

                    if (responseExport.data.message !== undefined && responseExport.data.message === 'Invalid request parameters') {
                        message = this.$t('cbax-instock-amazon-config.notifications.warning.marketplaceFailure');
                        this.createNotificationWarning({
                            title: this.$t('cbax-instock-amazon-config.notifications.warning.title'),
                            message: message
                        });
                    } else {
                        this.createNotificationSuccess({
                            title: this.$t('cbax-instock-amazon-config.notifications.success.title'),
                            message: message
                        });
                    }
                } else {
                    let message = this.$tc('cbax-instock-amazon-config.notifications.failure.export');
                    if (responseExport.data !== undefined && responseExport.data.message !== undefined && responseExport.data.message !== '') {
                        message = this.$tc(responseExport.data.message);
                    }
                    this.createNotificationError({
                        title: this.$tc('cbax-instock-amazon-config.notifications.failure.title'),
                        message: message,
                    });
                }
            }).catch((err) => {
                this.isLoading = false;

                this.createNotificationError({
                    title: this.$tc('cbax-instock-amazon-config.notifications.failure.title'),
                    message: this.$tc('cbax-instock-amazon-config.notifications.failure.export'),
                });
            });
        },

        onCancel() {
            this.$router.push({ name: 'cbax.external.order.configs' });
        }
    }
});
